"use strict";

exports.__esModule = true;
exports.AgendaEventsField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _finalForm = require("final-form");
var _reactFinalFormArrays = require("react-final-form-arrays");
var _core = require("@blueprintjs/core");
var _luxon = require("luxon");
var _reactBigCalendar = require("react-big-calendar");
var _dragAndDrop = _interopRequireDefault(require("react-big-calendar/lib/addons/dragAndDrop"));
require("react-big-calendar/lib/addons/dragAndDrop/styles.css");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _libCalendar = require("@vimana/lib-calendar");
var _CalendarEventFieldSet = require("../CalendarEvent/CalendarEventFieldSet");
var _PlantCalendar = require("../PlantCalendar");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _timeDefinitions = require("../../timeDefinitions");
var _class, _AgendaEventsField;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var getEventIndex = function getEventIndex(agenda, id) {
  for (var i = 0; i < agenda.eventConfigs.length; i++) {
    var event = agenda.eventConfigs[i];
    if (event.id === id) {
      return i;
    }
  }
  return 0;
};
var DnDCalendar = (0, _styledComponents["default"])((0, _dragAndDrop["default"])(_reactBigCalendar.Calendar)).withConfig({
  displayName: "AgendaEventsField__DnDCalendar",
  componentId: "sc-mrxwl2-0"
})([".rbc-month-view{min-height:800px;}.rbc-agenda-view{min-height:800px;}"]);
var WEEKDAYS = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
var CalendarRow = _styledComponents["default"].div.withConfig({
  displayName: "AgendaEventsField__CalendarRow",
  componentId: "sc-mrxwl2-1"
})(["display:flex;flex:1;"]);
var CalendarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AgendaEventsField__CalendarWrapper",
  componentId: "sc-mrxwl2-2"
})(["flex-grow:1;"]);
var CalendarSidebar = _styledComponents["default"].div.withConfig({
  displayName: "AgendaEventsField__CalendarSidebar",
  componentId: "sc-mrxwl2-3"
})(["display:flex;flex-basis:400px;border-left:1px solid rgba(0,0,0,0.2);padding:1rem;position:relative;background:", ";overflow-y:auto;"], (0, _Theme.val)("background"));
var CalendarSidebarCloseButton = _styledComponents["default"].div.withConfig({
  displayName: "AgendaEventsField__CalendarSidebarCloseButton",
  componentId: "sc-mrxwl2-4"
})(["background:none;border:none;cursor:pointer;position:absolute;top:0.5rem;right:0.5rem;"]);
var AgendaEventsField = exports.AgendaEventsField = (0, _Core.withTranslator)(_class = (_AgendaEventsField = /*#__PURE__*/function (_Component) {
  function AgendaEventsField() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      now: getNextSunday(new Date(_this.props.form.getState().values.interval.startMillis)),
      startMillis: _this.props.form.getState().values.interval.startMillis
    };
    _this.handleSelectEvent = function (selectedEvent) {
      _this.props.onSelectEventConfig(selectedEvent.sourceId);
    };
    _this.handleCloseSidebar = function () {
      _this.props.onSelectEventConfig(undefined);
    };
    _this.handleSelectSlot = function (_ref) {
      var start = _ref.start,
        end = _ref.end;
      var _this$props = _this.props,
        onCreateEventConfig = _this$props.onCreateEventConfig,
        agenda = _this$props.agenda;
      var from = start.toTimeString().slice(0, 5);
      var to = end.toTimeString().slice(0, 5);
      var occursWeekly = [WEEKDAYS[start.getDay()]];
      var existingShifts = agenda.eventConfigs.filter(function (item) {
        return item.type === "Shift";
      });
      var config = {
        id: Math.random().toString(16),
        type: "Shift",
        from: from,
        to: to,
        occursWeekly: occursWeekly,
        payload: {
          name: "Shift " + (existingShifts.length + 1)
        }
      };
      onCreateEventConfig(config);
    };
    _this.handleEventDrop = function (_ref2) {
      var event = _ref2.event,
        start = _ref2.start,
        end = _ref2.end;
      var startAt = _luxon.DateTime.fromJSDate(start);
      var from = startAt.toISOTime().slice(0, 5);
      var endAt = _luxon.DateTime.fromJSDate(end);
      var to = endAt.toISOTime().slice(0, 5);
      var _this$props2 = _this.props,
        form = _this$props2.form,
        agenda = _this$props2.agenda,
        prefix = _this$props2.prefix;
      var config = agenda.eventConfigs.find(function (item) {
        return item.id === event.sourceId;
      });
      var updated = Object.assign({}, config, {
        from: from,
        to: to
      });
      var weekday = (0, _libCalendar.getLuxonWeekday)(startAt);
      if (updated.occursWeekly.length === 1 && weekday !== updated.occursWeekly[0]) {
        updated.occursWeekly = [weekday];
      } else if (updated.occursWeekly.length !== 1 && !updated.occursWeekly.includes(weekday)) {
        updated.occursWeekly = [].concat(updated.occursWeekly, [weekday]);
      }
      var index = agenda.eventConfigs.findIndex(function (item) {
        return item.id === event.sourceId;
      });
      var _setIn = (0, _finalForm.setIn)(form.getState().values, prefix + ".eventConfigs[" + index + "]", updated),
        agendas = _setIn.agendas;
      form.change("agendas", agendas);
    };
    _this.handleEventResize = function (_ref3) {
      var event = _ref3.event,
        start = _ref3.start,
        end = _ref3.end;
      var startAt = _luxon.DateTime.fromJSDate(start);
      var from = startAt.toISOTime().slice(0, 5);
      var endAt = _luxon.DateTime.fromJSDate(end);
      var to = endAt.toISOTime().slice(0, 5);
      var _this$props3 = _this.props,
        form = _this$props3.form,
        agenda = _this$props3.agenda,
        prefix = _this$props3.prefix;
      var config = agenda.eventConfigs.find(function (item) {
        return item.id === event.sourceId;
      });
      var updated = Object.assign({}, config, {
        from: from,
        to: to
      });
      var index = agenda.eventConfigs.findIndex(function (item) {
        return item.id === event.sourceId;
      });
      var _setIn2 = (0, _finalForm.setIn)(form.getState().values, prefix + ".eventConfigs[" + index + "]", updated),
        agendas = _setIn2.agendas;
      form.change("agendas", agendas);
    };
    _this.handleDateChange = function (now) {
      _this.setState({
        now: now
      });
    };
    _this.removeEventConfig = function (prefix, index) {
      var form = _this.props.form;
      _this.handleCloseSidebar();
      form.mutators.remove(prefix + ".eventConfigs", index);
    };
    return _this;
  }
  _inheritsLoose(AgendaEventsField, _Component);
  AgendaEventsField.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    var startMillis = props.form.getState().values.interval.startMillis;
    if (prevState.startMillis === startMillis) {
      return null;
    }
    return {
      now: getNextSunday(new Date(startMillis)),
      startMillis: startMillis
    };
  };
  var _proto = AgendaEventsField.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props4 = this.props,
      translate = _this$props4.translator.translate,
      prefix = _this$props4.prefix;
    var date = this.state.now;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalFormArrays.FieldArray, {
      name: prefix + ".eventConfigs"
    }, function (_ref4) {
      var meta = _ref4.meta;
      var _this2$props = _this2.props,
        selectedEventConfigID = _this2$props.selectedEventConfigID,
        agenda = _this2$props.agenda,
        calendarConfig = _this2$props.calendarConfig;
      var index = selectedEventConfigID ? getEventIndex(agenda, selectedEventConfigID) : null;
      var calendar = new _libCalendar.Calendar(calendarConfig);
      return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        intent: meta.touched && meta.error ? "danger" : "secondary",
        helperText: meta.touched && meta.error ? meta.error : translate("AgendaEventsField.eventConfigs.helperText", "The events for this agenda."),
        label: translate("AgendaEventsField.eventConfigs.label", "Events"),
        labelFor: prefix + ".eventConfigs",
        requiredLabel: "*"
      }, /*#__PURE__*/_react["default"].createElement(CalendarRow, null, /*#__PURE__*/_react["default"].createElement(CalendarWrapper, null, /*#__PURE__*/_react["default"].createElement(_PlantCalendar.PlantCalendar, {
        date: date,
        component: DnDCalendar,
        calendar: calendar,
        agendaId: agenda.id,
        onEventDrop: _this2.handleEventDrop,
        onEventResize: _this2.handleEventResize,
        onSelectEvent: _this2.handleSelectEvent,
        onSelectSlot: _this2.handleSelectSlot,
        onNavigate: _this2.handleDateChange,
        selectable: true,
        resizable: true
      })), selectedEventConfigID && /*#__PURE__*/_react["default"].createElement(CalendarSidebar, null, /*#__PURE__*/_react["default"].createElement(CalendarSidebarCloseButton, {
        onClick: _this2.handleCloseSidebar
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: "cross"
      })), /*#__PURE__*/_react["default"].createElement(_CalendarEventFieldSet.CalendarEventFieldSet, {
        key: selectedEventConfigID,
        prefix: prefix + ".eventConfigs[" + String(index) + "]",
        onRemove: function onRemove() {
          return _this2.removeEventConfig(prefix, index);
        }
      }))));
    });
  };
  return AgendaEventsField;
}(_react.Component), _AgendaEventsField.defaultProps = {
  translator: undefined
}, _AgendaEventsField)) || _class;
function getNextSunday(asOf) {
  return new Date(asOf.getTime() + _timeDefinitions.DAY_IN_MILLIS * (7 - asOf.getUTCDay()));
}